import "./CalendarPage.css";

export default function CalendarPage() {
    return (
        <div className="event-page">
            <h1>KCRM Event Calendar</h1>
            <p><i><strong>Parking:</strong> Free parking is provided at Lenexa City Center, with garage entry points located on Winchester Street and 88th Street (accessible via Penrose Lane)</i></p>
            <br />
            <iframe title="KCRM Event Calendar" src="https://calendar.google.com/calendar/embed?height=600&wkst=1&ctz=America%2FChicago&showPrint=0&src=a2NyaWljaGlAZ21haWwuY29t&color=%23d50000"></iframe>
        </div>
    );
}